import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export * from '@/stores/modules/useTokenStore'
export * from '@/stores/modules/useUserInfoStore'
export * from '@/stores/modules/usePromoterInfoStore'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia
